import type dayjs from 'dayjs';

type ValidationResult = { valid: true } | { valid: false; message: string };

const ANNEES_AUTORISEES = [2025, 2026];

export const validerPeriodeEtatRecapitulatif = (
  dateDebut: dayjs.Dayjs | null,
  dateFin: dayjs.Dayjs | null,
): ValidationResult => {
  if (!dateDebut || !dateFin) {
    return { valid: false, message: 'Veuillez renseigner les deux dates.' };
  }
  if (dateFin.isBefore(dateDebut, 'day')) {
    return {
      valid: false,
      message: 'La date de fin doit être postérieure ou égale à la date de début.',
    };
  }
  if (dateDebut.year() !== dateFin.year()) {
    return {
      valid: false,
      message: 'La période doit être contenue dans une seule année calendaire.',
    };
  }
  if (!ANNEES_AUTORISEES.includes(dateDebut.year())) {
    return { valid: false, message: 'Seules les années 2025 et 2026 sont disponibles.' };
  }
  return { valid: true };
};
